/**
 * Created by rathompson on 4/13/22
 * File: AppImage
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import AppContext from '../../context/AppContext'
import { get } from 'lodash'
import { NoLogo } from '../../assets/images'

const AppImage = ({ app_id, ...rest }) => {

  const { apps } = useContext(AppContext)

  const src = useMemo(() => {
    return get(apps, `${app_id}.normalized_logo_url`, NoLogo)
  }, [app_id, apps])

  return <img src={src} alt={rest?.alt || 'img'} {...rest} />
}

AppImage.propTypes = {
  app_id: PropTypes.string.isRequired
}
export default AppImage

